module.exports = __webpack_public_path__ + "img/144.7fe14fb7.jpg";